import React from 'react';
import { Formik, Field } from 'formik';

// utils
import JSONparse from 'utils/json-parse-safe';

// components
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import Input from 'components/Fields/Input';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

interface FormValues {
  video_id: string;
}

const defaultValues: FormValues = {
  video_id: '',
};

interface Props {
  rawContent: string;
  onSubmit: (contentString: string, externalAssetId: string) => void;
  formId: string;
  isReadOly: boolean;
  closePanel: () => void;
}

const WistiaContent = ({ rawContent, onSubmit, formId, isReadOly, closePanel }: Props) => {
  const initialValues: FormValues = {
    ...defaultValues,
    ...JSONparse(rawContent).value,
  };

  const handleSubmit = (data: FormValues) => {
    const contentString = JSON.stringify(data);
    const { video_id: externalAssetId } = data;

    onSubmit(contentString, externalAssetId);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding>
            <Field tag="text_input_video_id" name="video_id" label="Video ID" component={Input} disabled={isReadOly} />
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default WistiaContent;
